import errCodes from './errCodes'
import variables from './variables'
import { version } from '../../../../package.json'

export const VERSION = version
export const QUESTION_TYPE_DANXUAN = 1
export const QUESTION_TYPE_DUOXUAN = 2
export const QUESTION_TYPE_TIANKONG = 3
export const QUESTION_TYPE_JIANDA = 4
export const QUESTION_TYPE_TEXT_MAP = {
  1: 'Single selection',
  2: 'Multiple selections',
  3: 'Gap filling',
  4: 'Free response'
}
export const QUESTION_TYPE_LANG_TEXT_MAP = {
  1: 'SingleSelection',
  2: 'MultipleSelections',
  3: 'GapFilling',
  4: 'FreeResponse'
}
export const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export default {
  errCodes,
  variables
}
export const questionType = {
  'question-detail': 2,
  'quizs': 2,
  'tests': 1,
  'courses': 0,
  'answer': 2
}

export const courseStatus = {
  1: 'Partially broadcast',
  2: 'To be broadcast',
  3: 'Already in replay'
}
export const chapterStatus = {
  1: 'Live',
  2: 'To be broadcast',
  3: 'Replay'
}

export const orderState = {
  WAIT_PAY: 1, // '未支付'
  SUCCESS_PAY: 2, // '已支付'
  TIMEOUT_PAY: 3, // '已超时'
  REFUND: 4, // '退款中'
  REFUND_OK: 5, // '退款成功'
  CANCELED_PAY: 6 // '已取消'
}

const payMethodsPrefix = process.env.VUE_APP_PAYMETHODS_PREFIX
export const PayMethods = {
  PC_WX: payMethodsPrefix + 'wx_pub_qr',
  NATIVE_WX: payMethodsPrefix + 'wx_wap',
  PC_ALI: payMethodsPrefix + 'alipay_pc_direct',
  MOBILE_ALI: payMethodsPrefix + 'alipay_wap'
}
